<!--
    课程分享-课时编辑-课时分类（弹窗）
    作用：编辑、新增、展示分类数据
    功能：课时分类数据，编辑/新增课时分类
    说明：版本3.0
-->
<template>
  <div class="type-select">
    <div class="type-selects2">
      <p class="title">课时分类：</p>
      <div class="select-box3">
        <span
          class="icon iconfont"
          @click="showEditDialog=true">
          <img
            :src="$assets.bianji"
            class="img"
            alt="" >
          <img
            :src="$assets.bianjiCur"
            class="img active"
            alt="" >
        </span>
        <el-cascader
          v-model="cascaderVal"
          :options="getNewTree"
          :props="{
            value: 'id',
            label: 'name',
            checkStrictly: true,
            children: 'recursive_children',
          }"
          clearable
          @change="handlerCascader"
        />
      </div>
    </div>
    <el-button
      style="margin-left:15px"
      @click="handlerMoveDialog">批量移动<span v-if="selClass.length">({{ selClass.length }})</span></el-button>
    <el-button
      v-if="selClass.length"
      style="margin-left:15px"
      @click="handlerCloseMove">取消批量移动</el-button>
    <!-- 课时分类编辑 -->
    <el-dialog
      :visible.sync="showEditDialog"
      :before-close="handleClose"
      custom-class="dialog-type-select"
      title="课时分类编辑"
      width="540px">
      <el-tree
        v-loading.lock="loading"
        ref="tree"
        :data.sync="newData"
        :props.sync="props"
        :default-expanded-keys="[0]"
        class="tree-box"
        node-key="id"
        @check="check"
      >
        <span
          slot-scope="{ node, data }"
          class="custom-tree-node">
          <span
            :class="{first: `${data.id}` === '0'}"
            class="title"
          >
            <span
              v-if="authConfig.add && `${data.id}` !== '0'"
              :class="{first: `${data.id}` === '0'}"
              class="add-icon"
              @click.stop="() => append(data, node)"
            >
              +
            </span>
            <span class="name">{{ node.label }}</span>
            <span
              v-if="`${data.id}` === '0'"
              class="angle el-tree-node__expand-icon el-icon-caret-right"/>
          </span>
          <span
            class="btns">
            <span
              v-if="authConfig.add && `${data.id}` === '0'"
              :class="{first: `${data.id}` === '0'}"
              class="add-icon"
              @click.stop="() => append(data, node)"
            >
              +
            </span>
            <span
              v-if="data.id !== 0 && authConfig.edit"
              class="btn edit"
              @click.stop="() => edit(data, node)"
            >编辑</span>
            <span
              v-if="data.id !== 0 && authConfig.delete"
              class="btn del"
              @click.stop="() => remove(node, data)"
            >删除</span>
          </span>
        </span>
      </el-tree>
      <TypeName
        v-if="isTypeName"
        :title="isEdit?'编辑分类':'新建分类'"
        :visible.sync="isTypeName"
        :default-value.sync="nodeObj"
        @success="addTypeGo"
      />
    </el-dialog>
    <!-- 移动弹窗 -->
    <type-dialog
      v-if="showMoveDialog"
      :visible.sync="showMoveDialog"
      :tree-data="getNewTree"
      :sel-class="selClass"
      @close-dialog="showMoveDialog = false"
      @refresh="handlerRefresh"/>
  </div>
</template>
<script>
import TypeName from './components/typeName';
import typeDialog from '../typeDialog.vue';
import { createCategory, updateCategory, delCategory } from '@/api/courseOn';

export default {
  name: 'TypeSelect',
  components: {
    TypeName,
    typeDialog,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    selClass: {
      type: Array,
      default: () => [],
    },
    treeData: {
      type: Array,
      require: true,
    },
    authConfig: {
      type: Object,
      default: () => ({
        add: true,
        edit: true,
        delete: true,
      }),
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    data: Array,
  },
  data() {
    return {
      showMoveDialog: false,
      cascaderVal: this.values,
      valueMe: this.values,
      showEditDialog: false,
      loading: false,
      isEdit: false,
      newIsShop: this.isShop,
      select: '',
      props: {
        children: 'recursive_children',
        label: 'name',
      },
      newData: [
        {
          id: 0,
          name: this.rootCatalog || '所有分类',
          delete: true,
          recursive_children: [],
        },
      ],

      typeSelet: '',
      addTypeNode: null, // 正在添加的节点
      isTypeName: false, // 添加分类名称
      dialogVisible: false, // 编辑分类
      clients_id: this.$store.state.choicesSchool.id,
    };
  },
  computed: {
    nodeObj() {
      const obj = {
        isEdit: this.isEdit,
        data: this.addTypeNode,
      };
      return obj;
    },
    getNewTree() {
      this.clearArrayEmpty(this.newData[0].recursive_children);
      return this.newData[0].recursive_children;
    },
  },
  watch: {
    newData: {
      handler(vl) {
        this.$emit('update:data', vl);
      },
      deep: true,
      immediate: true,
    },
    treeData: {
      handler(vl) {
        this.newData[0].recursive_children = this.treeData;
      },
      deep: true,
      immediate: true,
    },
    selectList(vl) {
      this.newData[0].childrens = vl;
    },
  },
  // mounted () {
  //   this.newData[0].recursive_children = this.treeData
  // },
  methods: {
    handlerCascader(val) {
      const searchVal = val[val.length - 1];
      this.$emit('changeVal', searchVal);
    },
    handlerRefresh() {
      this.$emit('refresh');
    },
    // 移动弹窗
    handlerMoveDialog() {
      if (this.selClass.length) {
        this.showMoveDialog = true;
      } else {
        this.$message.warning('请先选择课时！');
      }
    },
    // 取消批量移动
    handlerCloseMove() {
      this.$emit('closeMove');
    },
    handleClose() {
      this.showEditDialog = false;
    },
    // 剔除空数组
    clearArrayEmpty(data) {
      data && data.forEach((val) => {
        if (val.recursive_children) {
          if (val.recursive_children.length) {
            this.clearArrayEmpty(val.recursive_children);
          } else {
            val.recursive_children = undefined;
          }
        }
      });
    },
    check() {
      // 获取选中节点数组
      const arr = this.$refs.tree.getCheckedNodes();
      this.form.newValue = arr;
      this.isClearVilidate();
    },
    // 新增
    append(data, node) {
      console.log('append', data, node);
      this.isEdit = false;
      this.addTypeNode = data;
      this.isTypeName = true;
    },
    // 编辑
    edit(data, node) {
      this.isEdit = true;
      this.addTypeNode = data;
      this.isTypeName = true;
      console.log('edit', data, node);
    },
    // 删除
    remove(node, data) {
      this.loading = true;
      delCategory(this.$store.state.choicesSchool.id, {
        id: data.id,
        packet_id: this.$route.query.packetId,
      }).then((res) => {
        if (res.status_code === 200) {
          this.$message.success('删除成功!');
          const parent = node.parent;
          const childrens = parent.data.recursive_children || parent.data;
          const index = childrens.findIndex(d => d.id === data.id);
          childrens.splice(index, 1);
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 添加分类
    addTypeGo({ isEdit, name }) {
      this.addType({ isEdit, data: this.addTypeNode, name });
    },
    addType({ isEdit, data, name }) {
      this.loading = true;
      const obj = {
        packet_id: this.$route.query.packetId,
        parent_id: data.id,
        name,
      };
      if (isEdit) {
        obj.id = this.nodeObj && this.nodeObj.data && this.nodeObj.data.id;
        obj.parent_id = this.nodeObj && this.nodeObj.data && this.nodeObj.data.parent_id;
        // 编辑分类
        updateCategory(this.$store.state.choicesSchool.id, obj).then((res) => {
          if (res.status_code === 200) {
            this.$message.success('修改成功!');
            data.name = name;
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // 新增分类
        createCategory(this.$store.state.choicesSchool.id, obj).then((res) => {
          if (res.status_code === 200) {
            this.$message.success('添加成功!');
            if (!data.recursive_children) {
              this.$set(data, 'recursive_children', []);
            }
            data.recursive_children.push(res.data);
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.type-select{
    display: flex;
    .type-selects2{
      display: flex;
      flex-direction: row;
      align-items: center;
      .title{
        font-size: 14px;
        font-weight: 400;
        color: #333436;
        line-height: 14px;

        &.first{
          color: #333436;
        }
      }

      .select-box3{
        position: relative;

        .icon{
          width: 12px;
          height: 12px;
          display: inline-block;
          font-size: 12px;
          position: absolute;
          top: 10px;
          left: 16px;
          z-index: 10;
          margin-right: 10px;
          margin-top: 3px;
          cursor: pointer;
          color: #9C9FA4;

          .active{display: none;}
          .img {
            float: left;
          }

          &:hover{
            color: #EFB600;

            .img{
              display: none;
              &.active{
                display: inline-block;
              }
            }

          }

          &:after{
            content: '';
            top: 0px;
            right: -12px;
            width: 1px;
            height: 14px;
            position: absolute;
            background: #DCDFE6;
          }
        }

        & /deep/ .el-input__inner{
          padding-left: 50px;
        }
      }
    }

    .btns{
      .add{
        width: 16px;
        height: 11px;
        margin-left: 30px;
      }
      .edit{
        margin-left: 10px;
        color: #9f9f9f;
      }
      .del{
        width: 13px;
        height: 12px;
        margin-left: 10px;
      }
    }
  }
</style>
<style lang="scss">
.dialog-type-select {
  .el-tree{width: 100%;}
  .el-dialog__header{
    border-bottom: 1px solid #E9E9E9;
  }

  .el-tree-node__content>.el-tree-node__expand-icon{
    padding: 6px 14px;
    margin-left: 10px;
  }
  .el-tree-node__expand-icon{
    color: #1A1C2B;
  }
  .el-tree-node__expand-icon.is-leaf{
    color: transparent;
  }

  .el-tree-node.is-expanded{
    .title.first .angle{
      transform: rotate(90deg);
    }
  }

  .title.first{
    position: relative;
    margin-left: 14px;

    .angle{
      margin-left: 20px;
      display: inline-block !important;
    }
  }
  .el-tree-node__children .el-tree-node__expand-icon.is-leaf + .custom-tree-node{
    .title {
      position: relative;
      left: -16px;

      .add-icon {
        position: relative;
        left: -8px;
        top: -1px;
      }
    }
  }

  .el-dialog__body .tree-box>.el-tree-node>.el-tree-node__content:first-child{
    .el-tree-node__expand-icon{
      display: none;
    }
  }

  .tree-box {
    margin-left: 40px;
    margin-right: 40px;
    min-height: 200px;
    width: inherit;

    .custom-tree-node{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: relative;

      &>.title{
        position: relative;
        display: flex;
        align-items: center;
      }

      .btns{
        margin-right: 16px;

        .btn{
          font-size: 14px;
          margin-left: 16px;
          font-weight: 400;
          color: #EEB500;
          line-height: 14px;
        }
      }

      .add-icon{
        position: absolute;
        left: -55px;
        top: 12px;
        width: 14px;
        height: 14px;
        line-height: 12px;
        text-align: center;
        display: inline-block;
        border-radius: 2px;
        border: 1px solid #333436;

        &.first{
          position: initial;
          background: #333436;
          color: white;
        }
      }
    }

    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      background: #F5F7FA;
      border-radius: 4px;
    }

    .is-expanded > .el-tree-node__content {
      background: #E5E8F0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/editClassHours/components/typeSelect/index.vue